<template>
    <MainContent title="Gestor de medios">
        <template v-slot:header>
            <h3 class="card-title mb-3">Gestor de medios</h3>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <b-row>
                    <b-col cols="12" md="4" lg="2" class="mt-3 mt-md-0">
                        <div class="form-group w-100 mb-5">
                            <label v-if="!previewImg" for="imageUpload" class="btn bg-light w-100 py-5 mb-2" style="border: 2px dashed #007bff;">
                                Seleccionar imagen
                                <input
                                    type="file"
                                    id="imageUpload"
                                    class="d-none"
                                    @change="onFileChange"
                                    accept="image/*"
                                />
                            </label>
                            <div v-if="previewImg" class="position-relative my-2">
                                <div 
                                    class="text-center fw-bolder text-danger mb-1"
                                    style="cursor: pointer;" 
                                    @click="borrarPreviewImage"
                                >
                                    <p class="small m-0">Eliminar imagen</p>
                                </div>
                                <div class="w-100" style="max-height: 200px; overflow: hidden;display: flex;justify-content: center;">
                                    <img :src="previewImg" class="img-fluid rounded border" style="max-height: 200px;  object-fit: cover;"/>
                                </div>
                            </div>
                            <b-button
                                class="w-100 btn-secondary custom-border mt-2"
                                :disabled="!formCreateImg.imagen"
                                @click="createImagenesMedios(formCreateImg)"
                            >
                                Subir imagen
                            </b-button>
                        </div>
                        <ListadoCarpetas
                            :carpetas="carpetas"
                            :loading.sync="loading"
                            :nombre="nombreCarpetas"
                            :totalItems="'total_imagenes'"
                            @createCarpeta="createCarpeta"
                            @editCarpeta="editCarpeta"
                            @deleteCarpeta="deleteCarpeta"
                            @getCarpetas="getCarpetas"
                            @getItems="() =>  formCreateImg.carpeta_id = null "
                            @filterCarpeta="(carpeta_id) =>  formCreateImg.carpeta_id = carpeta_id " 
                        />
                    </b-col>
                    <b-col cols="12" md="12" lg="10">
                        <div class="mb-3">
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Buscar imágenes por nombre..."
                                        v-model="filtersImagenes.search"
                                    />
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            <ListadoImagenes
                                :carpeta_id="formCreateImg.carpeta_id"
                                :search="filtersImagenes.search"
                            />
                        </div>
                    </b-col>
                </b-row>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent.vue";
    import ListadoCarpetas from "@/components/backend/campana-emails/boletines/ListadoCarpetas.vue";
    import apiService from "@/services/api-comunicados";
    import ListadoImagenes from "@/components/backend/campana-emails/medios/ListadoImagenes.vue";
    import _ from 'lodash';

    export default {
        data() {
            return {
                loading: false,
                nombreCarpetas: "Todas las Imágenes",
                carpetas: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 },
                },
                totalItems: 0,
                filterscarpetasImagenes: {
                    search: '',
                    per_page: 10,
                },
                filtersImagenes: {
                    search: '',
                },
                formCreateImg: {
                    nombre: '',
                    imagen: null,
                    carpeta_id: null,
                },
                previewImg: null,
                imagenes: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 },
                },
            };
        },
        created() {
            this.getCarpetas();
        },
        methods: {
            async getCarpetas(textoFiltro) {
                if(textoFiltro != null){
                    this.filterscarpetasImagenes.search = textoFiltro
                }
                try {
                    const response = await apiService.getCarpetasImagenes(
                        this.filterscarpetasImagenes
                    );
                    this.carpetas = {
                    ...response,
                    data: response.data.map(carpeta => ({
                        ...carpeta,
                        showIcons: false,
                    })),
                    };
                } catch (error) {
                    console.error("Error al obtener las carpetas", error);
                }
            },
            async createCarpeta(data) {
                try {
                    this.loading = true;

                    await apiService.createCarpetasImagenes({
                        nombre: data.nombre,
                        descripcion: data.descripcion,
                    });

                    this.$toast.success("Carpeta creada correctamente");
                    this.$modal.hide("crear-carpeta");
                    this.getCarpetas();
                } catch (error) {
                    console.error("Error al crear la carpeta:", error);
                    this.$toast.error("Hubo un error al crear la carpeta");
                } finally {
                    this.loading = false;
                }
            },
            async editCarpeta(data) {
                try {
                    await apiService.updateCarpetasImagenes(data);
                    this.$toast.success("Carpeta actualizada correctamente");
                    this.$modal.hide("editar-carpeta");
                    this.getCarpetas();
                } catch (error) {
                    this.$toast.error("Error al actualizar la carpeta");
                }
            },
            async deleteCarpeta(data) {
                try {
                    this.loading = true;
                    await apiService.deleteCarpetasImagenes(data.id);
                    this.$toast.success("Carpeta eliminada correctamente");
                    this.getCarpetas();
                } catch (error) {
                    console.error("Error al eliminar la carpeta:", error);
                    this.$toast.error("Hubo un error al eliminar la carpeta");
                } finally {
                    this.carpetaAEliminar = null;
                    this.$modal.hide("eliminar-carpeta");
                    this.loading = false;
                }
            },
            onFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    this.formCreateImg.imagen = file
                    const nombreModificado = file.name.replace(/\.[^/.]+$/, "");
                    this.formCreateImg.nombre = nombreModificado;

                    const reader = new FileReader();
                    reader.onload = e => {
                        this.previewImg = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            },
            borrarPreviewImage() {
                this.previewImg = null;
                this.formCreateImg.imagen = null;
            },
            async createImagenesMedios(formCreateImg) {
                try {
                    this.loading = true;
                    
                    const formData = new FormData();
                    formData.append('nombre', formCreateImg.nombre);
                    formData.append('imagen', formCreateImg.imagen);
                    if (formCreateImg.carpeta_id) {
                        formData.append('carpeta_id', formCreateImg.carpeta_id);
                    }
                    
                    await apiService.createImagenesMedios(formData);
                    
                    this.$toast.success("imagen creada correctamente");
                    this.getCarpetas();
                    this.previewImg = null;
                    this.formCreateImg = {
                        nombre: '',
                        imagen: null,
                        carpeta_id: null,
                    };
                } catch (error) {
                    console.error("Error al crear la imagen:", error);
                    this.$toast.error("Hubo un error al crear la imagen");
                } finally {
                    this.loading = false;
                }
            },
        },
        components: {
            ListadoCarpetas,
            MainContent,
            ListadoImagenes
        },
    };
</script>
<style scoped>
.custom-border:disabled {
    border: 1px solid rgb(0, 0, 0);
    color: black; 
}
.custom-border:not(:disabled) {
    border: none; 
}
</style>